import type { July4848PromoVariant } from '~/features/promotions/constants/july-48-48-promo';
import {
  getJuly4848PromoSlideKey,
  getJuly4848PromoVariant,
  resolveJuly4848PromoVariant,
} from '~/features/promotions/utils/get-july-48-48-promo-variant';

import type { PromoCampaignSurfaceRenderers } from '../types';

export const JULY_48_48_PROMO_CAMPAIGN_ID = 'july-48-48-promo';

export const july4848PromoCampaignCore: Pick<
  PromoCampaignSurfaceRenderers<July4848PromoVariant>,
  'id' | 'getSlideKey' | 'matches' | 'isGateReady' | 'resolve'
> = {
  id: JULY_48_48_PROMO_CAMPAIGN_ID,
  getSlideKey: ({ resolved }) => getJuly4848PromoSlideKey(resolved),
  matches: ({ forcedPromotionId, promotionId }) =>
    getJuly4848PromoVariant(forcedPromotionId) != null || getJuly4848PromoVariant(promotionId) != null,
  isGateReady: ({ forcedPromotionId, promotionFetched }) =>
    getJuly4848PromoVariant(forcedPromotionId) != null || promotionFetched,
  resolve: ({ forcedPromotionId, promotionId }) => resolveJuly4848PromoVariant(forcedPromotionId, promotionId),
};
